import { useMemo } from "react";
import { useSelector } from "react-redux";
import classes from "./NoteCell.module.css";
import classesCell from "./BodyCell.module.css";
import { useWorkQShell } from "../context/workQShellContext";
import { filterNotesByPermission } from "../../../lib/notesPermissions";
import { omitDeletedRecords } from "../../../lib/noteDelete";

export default function NoteCell({ caseData, notes, workq }) {
    const shell = useWorkQShell();
    const editPermissions = useSelector(state => state.permissions.editPermissions);
    const permittedNotes = useMemo(
        () => omitDeletedRecords(filterNotesByPermission(notes, editPermissions)),
        [notes, editPermissions]
    );

    function openListPopover(rect) {
        if (!shell) return;
        shell.openPopover({
            kind: "notes_list",
            rect,
            caseData,
            notes: permittedNotes,
            workq,
            dismissMode: "outside",
        });
    }

    function openAddModal() {
        if (!shell) return;
        shell.openModal({
            kind: "modal_add_note",
            caseData,
            workq,
        });
    }

    return (
        <div className={`${classes.note_cell} ${classesCell.body_cell}`}>
            {permittedNotes && permittedNotes.length > 0 && (
                <button
                    title="notes list"
                    type="button"
                    onClick={(e) => openListPopover(e.currentTarget.getBoundingClientRect())}
                    className={`${classes.button_cell} `}
                >
                    <span className={classes.show_notes_number}>{permittedNotes.length}</span>
                </button>
            )}

            {(!permittedNotes || (permittedNotes && permittedNotes.length == 0)) && (
                <button title="add new note" type="button" onClick={openAddModal} className={`${classes.button_cell} `}>
                    <span className={classes.show_notes_number}>
                        <i className="ti ti-plus"></i>
                    </span>
                </button>
            )}
        </div>
    );
}
